import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import Script from 'next/script';
import { AuthSession } from 'hooks/useAuth';
import Cookies from 'js-cookie';
import { COOKIES } from 'libs/constants';

function GA() {
  return (
    <Script
      id="ga-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
                        window.ga = window.ga || function () {(ga.q = ga.q || []).push(arguments)}; ga.l = +new Date;
                      `
      }}
    />
  );
}

function Sift() {
  const auth = AuthSession();
  const siftSessionId = Cookies.get(COOKIES.siftSessionId) || '';
  const {
    user: { id: userId },
    isAuthenticated
  } = auth;
  const siftKey = process.env.NEXT_PUBLIC_SIFT_KEY;

  if (isAuthenticated === undefined) return null;

  return (
    <Script
      id="sift-script"
      strategy="afterInteractive"
      src="https://cdn.sift.com/s.js"
      dangerouslySetInnerHTML={{
        __html: `
          var _sift = window._sift = window._sift || [];
          _sift.push(['_setAccount', '${siftKey}']);
          _sift.push(['_setUserId', '${userId || 0}']);
          _sift.push(['_setSessionId', '${siftSessionId}']);
          _sift.push(['_trackPageview']);
        `
      }}
    />
  );
}

function PA() {
  const auth = AuthSession();
  const { isAuthenticated } = auth;
  if (!isAuthenticated) return null;

  return (
    <Script
      id="pa-script"
      strategy="afterInteractive"
      src={
        process.env.NEXT_PUBLIC_DEPLOY_TARGET === 'development'
          ? 'https://cdn.sbx-2.particularaudience.com/js/keen/t.js'
          : 'https://cdn-us.particularaudience.com/js/keen/t.js'
      }
      dangerouslySetInnerHTML={{
        __html: `
                       window.addPAC = function (c, e) { document.cookie = 'PAC=' + c + ';' + e + ';' };
                      `
      }}
    />
  );
}

function Layout({ children }): JSX.Element {
  useEffect(() => {
    TagManager.initialize({ gtmId: process.env.NEXT_PUBLIC_GTM_ID });
  }, []);
  return (
    <>
      <GA />
      <Sift />
      <PA />
      {children}
    </>
  );
}

export default Layout;
